module.exports = __webpack_public_path__ + "static/media/Mystino_july.3ea1c0fa.png";